import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface DashboardSearchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const DashboardSearch = ({ className, ...props }: DashboardSearchProps) => {
  return (
    <div className="relative">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 z-20">
        <Search size={16} className="text-accent" />
      </div>
      
      <Input 
        placeholder="Search resources..." 
        className={`pl-10 h-10 text-sm font-medium ${className}`}
        {...props}
      />
    </div>
  );
};

export default DashboardSearch;
